<section>
    <div class="info">
        <div class="info-icon">
            <xm-media-image aria-hidden="true" [imageOptions]="imageOptions" size="auto"></xm-media-image>
        </div>
        <div class="data">
            <h4 class="saver-name">{{ pageData.dataSaverData.header }}</h4>
            <p class="saver-price">{{ pageData.dataSaverData.price }}</p>
            <p class="saver-subheader">{{ cmsData.description }}</p>
            <p class="foot-note" *ngIf="isStatusOn">{{ pageData.dataSaverData.footNote }}</p>
        </div>
        <div class="btn-action">
            <div class="icon-wrapper" *ngIf="isStatusOn">
                <xm-media-image [imageOptions]="inUseIcon" class="use-icon"></xm-media-image>
                <span class="action-text">{{ pageData.inUse }}</span>
            </div>
            <button class="xm-btn-secondary-light" [ngClass]="{'disabled': !isActiveLine}" [disabled]="!isActiveLine" (click)="openDatasaverModal()"><span>{{ cmsData.cta }}<span class="accessibility-hidden"> {{ cmsData.btnAllySuffix }}</span></span></button>
        </div>
    </div>
</section>
